module.exports = __webpack_public_path__ + "img/tab2.0.1.0_202508261531.png";